import styled from 'styled-components';
import colors from '../../../utils/colors';

// Success Splash Elements
export const Button = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	padding: 16px 24px;
	border-radius: 100px;
	background: rgba(255, 255, 255, 0.05);
	transition: 250ms all;

	backdrop-filter: blur(12px);
	color: ${colors.blGrayscale200};
	font-size: 13px;
	font-weight: 600;
	line-height: 16px;

	&.link {
		display: flex;
		justify-content: center;
		align-items: center;
		color: ${colors.blGrayscale200};
		cursor: pointer;
		gap: 8px;
		box-shadow: none;

		svg {
			margin-right: 0;
		}

		&.config-page {
			background: transparent;
		}
	}

	&.success {
		border: 1px solid ${colors.blGrayscale300};
	}

	// Conference View Config Button Styles
	width: fit-content;

	label, path, a {
		transition: 250ms all;
	}

	:hover {
		background: rgba(255, 255, 255, 0.15);
	}

	:active {
		background: rgba(255, 255, 255, 0.05);

		label, a {
			color: ${colors.blGrayscale300} !important;
		}

		svg>path {
			fill: ${colors.blGrayscale300} !important;
		}
	}

	&.transparent {
		background: transparent;
	}

	&.gradient {
		@property --gradColor1 {
			syntax: '<color>';
			initial-value: rgba(255, 255, 255, 0);
			inherits: false;
		}

		@property --gradColor2 {
			syntax: '<color>';
			initial-value: rgba(255, 255, 255, 0);
			inherits: false;
		}

		background: linear-gradient(0deg, var(--gradColor1) 0%, var(--gradColor2) 100%), linear-gradient(90deg, #FF6AE6 0%, #FFF85C 100%); 
  		transition: --gradColor1 250ms, --gradColor2 250ms;

		:hover {
			--gradColor1: rgba(255, 255, 255, 0.10);
  			--gradColor2: rgba(255, 255, 255, 0.10);
		}
		
		:active {
			--gradColor1: rgba(0, 0, 0, 0.20);
  			--gradColor2: rgba(0, 0, 0, 0.20);

			label {
				color: ${colors.blGrayscale1200} !important;
			}

			svg>path {
				fill: ${colors.blGrayscale1200} !important;
			}
		}
	}
`;

export const ButtonLabel = styled.label`
	font-size: 13px;
	font-weight: 600;
	line-height: 16px;
	cursor: pointer;
`;

// Conference View Config Elements
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const ContainerHeader = styled.h2`
	font-size: 30px;
	font-weight: 700;
	line-height: 40px;
	background: linear-gradient(104.42deg, #ff6ae6 -4.67%, #fff85c 69.07%, #a6ff79 120.95%);
	background-clip: text;
	-webkit-text-fill-color: transparent;
	margin: 0 0 8px 0;
`;

export const ContainerSubHeader = styled.h4`
	font-size: 20px;
	font-weight: 600;
	line-height: 32px;
	letter-spacing: -0.2px;
	color: #FFF;
	margin: 0;
`;

export const ConfigContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	padding: 0 20px;
`;

export const ViewOptionsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
	width: 100%;
	margin: 24px auto 0;
`;

export const ViewOption = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-self: stretch;
	align-items: center;
	width: 320px;
	height: 239px;
	padding: 16px;
	border-radius: 16px;
	cursor: pointer;
	text-align: center;
	gap: 5.316px;
	border-radius: 16px;
	backdrop-filter: blur(16px);

	@property --viewGradColor1 {
		syntax: '<color>';
		initial-value: rgba(0, 0, 0, 0.40);
		inherits: false;
	}

	@property --viewGradColor2 {
		syntax: '<color>';
		initial-value: rgba(0, 0, 0, 0.40);
		inherits: false;
	}

	background-image: linear-gradient(90deg, var(--viewGradColor1) 0%, var(--viewGradColor2) 100%);
	transition: --viewGradColor1 0.2s, --viewGradColor2 0.2s, box-shadow 0.2s ease-in-out;

	h3 {
		color: #E5E4EC;
		text-align: center;
		font-size: 16px;
		font-weight: 600;
		line-height: 20px;
		margin: 0;
		transition: color 0.2s ease-in-out;
	}

	p {
		color: #E5E4EC;
		text-align: center;
		font-size: 11px;
		font-weight: 600;
		line-height: 16px;
		letter-spacing: 0.22px;
		margin: 0;
		transition: color 0.2s ease-in-out;
	}

	:hover {
		--viewGradColor1: rgba(255, 106, 230, 0.40);
		--viewGradColor2: rgba(255, 248, 92, 0.40);
	}

	&.selected {
		--viewGradColor1: #FF6AE6;
		--viewGradColor2: #FFF85C;
		box-shadow: -6px 2px 20px 0px rgba(255, 253, 98, 0.35), 6px -2px 20px 0px rgba(255, 106, 230, 0.35);

		h3, p, svg {
			color: ${colors.blGrayscale1200};
		}

		svg > path, svg > rect {
			transition: fill 0.2s ease-in-out;
			fill: ${colors.blGrayscale1200} !important;
		}
	}
`;

export const SubOptions = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
	width: 100%;
	margin: 24px auto 16px;
`;

export const AnimatedWrapper = styled.div`
	grid-column: 1 / -1;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
	height: 0;
	opacity: 0;
	overflow: hidden;
	transition: height 0.3s ease-in-out, opacity 0.2s ease-in-out;

	&.visible {
		height: 40px;
		opacity: 1;
	}
`;

export const LocationContainer = styled.div`
	position: relative;
	width: 100%;
	max-width: 320px;
`;

export const EntryDropdownButton = styled.button`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 40px;
	padding: 12px 16px;
	gap: 8px;
	background: transparent;
	border-radius: 20px;
	border: 1px solid ${colors.blGrayscale400};
	width: 100%;

	:hover, :active {
		background: transparent;
	}

	&.open {
		border: 1px solid ${colors.blGrayscale200};
	}

	&.single {
		padding-right: 32px;
		cursor: default;
	}
`;

export const EntryDropdownButtonText = styled.h2`
	font-size: 12px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.24px;
	margin: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	color: ${colors.blGrayscale400};

	&.selected {
		color: ${colors.blGrayscale100};
	}
`;

export const EntryDropdown = styled.div`
	position: absolute;
	top: 48px;
	left: 0;
	width: calc(50% - 8px); /* Match the width of one grid column accounting for gap */
	background: rgba(0, 0, 0, 0.4);
	backdrop-filter: blur(16px);
	border-radius: 12px;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.2s ease-in-out;
	z-index: 100;

	&.open {
		opacity: 1;
		pointer-events: all;
	}
`;

export const EntryDropdownOption = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 10px 16px;
	background: ${colors.blGrayscale800};
	min-height: 36px;

	&.header {
		padding: 8px 16px;
		color: ${colors.blGrayscale400};
	}

	&:not(.header)&:not(.no-locations) {
		cursor: pointer;

		&:hover {
			background: ${colors.blGrayscale700};
		}
	}
`;

export const CheckboxButton = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	block-size: fit-content;
	padding: 12px 20px;
	gap: 8px;
	border-radius: 100px;
	background: rgba(255, 255, 255, 0.05);
	font-size: 13px;
	font-weight: 600;
	white-space: nowrap;
	transition: 250ms all;
	cursor: pointer;

	input[type=checkbox] {
		width: 12px;
		height: 12px;
		accent-color: ${colors.blGrayscale100};
		cursor: pointer;
	}

	:hover {
		background: rgba(255, 255, 255, 0.15);
	}

	:active {
		background: rgba(255, 255, 255, 0.05);
	}
`;

// Entry Code Elements
export const EntryCodeContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 142px;
`;

export const CodeBox = styled.input`
    width: 64px;
	height: 64px;
	padding: 16px 0px 20px 0px;
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.15);
	backdrop-filter: blur(5px);
	border: none;
	outline: none;
	font-family: 'Poppins', sans-serif;
	font-weight: 700;
	font-size: 30px;
	line-height: 40px;
	text-align: center;
	color: white;

	&:focus {
		border: 1px solid white;
	}
`;

// Conference Room Entry Elements
export const ConferenceRoomEntryContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 662px;
    position: relative;

    .conference-room-header {
        margin-bottom: 60px;

        h1 {
            font-family: 'Poppins', sans-serif;
            font-weight: 700;
            font-size: 50px;
            line-height: 55px;
            text-align: center;
            color: #CBFF47;
            margin: 0;
        }
    }

    .conference-room-content {
        display: flex;
        flex-direction: column;
        gap: 60px;
        width: 100%;
        align-items: center;
    }

    .sip-section,
    .code-section {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: center;
        width: 100%;
    }

    .section-label {
        font-family: 'Poppins', sans-serif;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        color: #9B97A1;
        margin: 0;
        max-width: 660px;
    }

    .code-inputs {
        display: flex;
        gap: 12px;
        justify-content: center;
    }

    .platform-buttons {
        display: flex;
        gap: 0;
        align-items: center;
        margin-top: 60px;
        opacity: 0.8;
    }
`;

export const SIPAddressDisplay = styled.div`
    display: inline-block;
    align-items: center;
    justify-content: center;
    height: 80px;
    padding: 16px 24px 20px 24px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(5px);
    border-radius: 12px;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    color: white;
`;

export const PlatformButton = styled.div`
    display: flex;
    align-items: center;
    gap: 9.103px;
    padding: 12.137px 12px;
    background: transparent;
    border: none;
    border-radius: 151.717px;

    img, svg {
        width: 18px;
        height: 18px;
        opacity: 0.8;
    }

    span {
        font-family: 'Poppins', sans-serif;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #D9D6DE;
        white-space: nowrap;
    }
`;
